export const dark = '#0a0a0c'
export const darkLighter = '#585859'
export const accetYellow = '#ed9b3b'
export const red = '#b93636'
export const yellow = "#f6c778"
export const cyan = "#5cc1ac"
export const gray = "#4f4e53"